import Vue from 'vue'
import VueRouter from 'vue-router'
import Vitrine from '../views/Vitrine.vue'
import Artigo from '../views/Artigo.vue'
import Artigos from '../views/Artigos.vue'
import Cesta from '../views/Cesta.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Vitrine
  },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Vitrine
  // },
  {
    path: '/vitrine',
    name: 'Vitrine',
    component: Vitrine
  },
  {
    path: '/artigo',
    name: 'Artigo',
    component: Artigo
  },
  {
    path: '/artigos',
    name: 'Artigos',
    component: Artigos
  },
  {
    path: '/cesta',
    name: 'Cesta',
    component: Cesta
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
scrollBehavior() {
    return {x: 0, y: 0}
}
})

export default router
